import { GlobalToken } from 'antd';
import styled from 'styled-components';

export const Container = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginXXS}px;

  &.activity-indication-horizontal {
    flex-direction: row;
  }

  &.activity-indication-vertical {
    flex-direction: column;
  }

  &.activity-indication-small {
    gap: ${({ theme: { token } }) => token.marginXXS}px;

    .activity-label {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    }
  }

  &.activity-indication-large {
    gap: ${({ theme: { token } }) => token.marginXS}px;

    .activity-label {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
    }
  }

  .activity-label {
    color: ${({ theme: { token } }) => token.colorTextDescription};
  }
`;
